var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.sms-svg .st0{fill:#566d94;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "sms-svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,1.8h-48C3.8,1.8,0,5.6,0,10.3v29.9c0,4.6,3.8,8.4,8.4,8.4h8.4v10.1c0,1.5,1,2.9,2.4,3.4 c0.4,0.1,0.8,0.2,1.2,0.2c1.1,0,2.1-0.5,2.8-1.4l9.8-12.4h22.6c4.7,0,8.4-3.8,8.4-8.4V9.2C64,5.1,60.7,1.8,56.6,1.8z M56.9,40 c0,0.7-0.6,1.3-1.3,1.3H31.9c-0.6,0-1.1,0.1-1.6,0.4l-1.1,0.6c-0.5,0.2-0.9,0.6-1.2,1l-4.1,5.2v-2c0-0.9-0.4-1.8-1-2.5l-1.4-1.4 c-0.7-0.7-1.6-1.1-2.5-1.1H8.4c-0.7,0-1.3-0.6-1.3-1.3V10.3c0-0.8,0.6-1.4,1.4-1.4h48c0.2,0,0.3,0.1,0.3,0.3V40z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 18.1,
    cy: 25,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.1,
    cy: 25,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 46,
    cy: 25,
    r: 4.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.c2041c2d87b285b8f4a6f3a60ec7394c.svg";
export { ForwardRef as ReactComponent };